import { closeCurrentWebView } from "@/utils/native/interaction";

export default [
  {
    path: "/wt-qa",
    name: "WtQA",
    meta: {
      title: "疑难解答",
      customBackFn: closeCurrentWebView,
      theme: "transparent"
    },
    component: () => import(/* webpackChunkName: "qa" */ "@/views/qa/index.vue")
  }
];
